import { formatTitleCase } from './formatTitleCase'

// default: return title-cased string separated by spaces (i.e. "No Sale", "Exited")
// custom: add case/test for other formats as requested
export const formatSaleStatus = (status: string | null | undefined): string => {
    if (typeof status === 'string') {
        switch (true) {
            case status === 'offer':
                return 'If/Offer'
            case status === 'nos':
                return 'No Sale'
            default:
                return formatTitleCase(status.split('-').join(' '))
        }
    }
    return ''
}
